export function DesMoinesCountyRoadTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Road Name</th>
                  <td class="two-third">{Road Name}</td>
              </tr>
              <tr>
                  <th class="third">Road Type</th>
                  <td class="two-third">{Road Type}</td>
              </tr>
              <tr>
                  <th class="third">Project Type</th>
                  <td class="two-third">{Project Type}</td>
              </tr>
              <tr>
                  <th class="third">Related File</th>
                  <td class="two-third">
                      <a target="_blank" href="https://www.dmcgis.com/images/HistRoads/{Image_Name}.pdf" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  